import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonIndicatorComponent } from './button-indicator.component';

@Component({
  selector: 'app-button-indicator-download',
  imports: [ButtonIndicatorComponent],
  template: `
    <app-button-indicator
      areaLabelT="admin.reports.download"
      toolTipT="admin.reports.download"
      svgIcon="download"
      [isPending]="isPending"
      (clicked)="this.clicked.emit(undefined)"
    />
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonIndicatorDownloadComponent {
  @Input() isPending: boolean;
  @Output() clicked = new EventEmitter<Event>();
}
